import { css } from 'styled-components';

export const StyledPublicFontFamily = css``;
